

import { Collapse } from 'antd';
import React, {useState, useEffect} from 'react';
import { copyCollection, firestore } from "./utils/database";

import { Affix, Button, Card, Checkbox, Divider, Form, Input, message, PageHeader, Pagination, Progress, Typography, Popover, Radio, Select, Slider, Steps } from "antd";

import fetchLikedContent, {conf_ID, getConferenceContent} from "./utils/misc";

const { Panel } = Collapse;
const { Option } = Select;
const { Step } = Steps;
const { Text } = Typography;

let already_answered = [];

const LabelResearchers = () => {
    const [displayQFlag, setDisplayQFlag] = useState(false);
    const [user, setUser] = useState({});
    const [users, setUsers] = useState([]);
    const [researcher, setResearcher] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [minIndex, setMinIndex] = useState(0);
    const [maxIndex, setMaxIndex] = useState(5);
    const [topicEnabled, setTopicEnabled] = useState(true);

    const [form] = Form.useForm();

    const [messageApi, contextHolder] = message.useMessage();

    const stage_dict = {"undergraduate": "a undergraduate student", "graduate": "a graduate student", "postdoc": "post-doc", "faculty": "professor", "industry": "researcher", "other": "researcher"};
    
    const mandatory_threshold = 5;

    useEffect(() => {
        const uid = getUrlParameter("id");

        if(!uid) {
            alert("Invalid link! Please use the custom link. If you can't find it, please email me at soya@mit.edu");
            return;
        }

        async function fetchSettings() {
            const snapshot = await firestore.collection('profiles').get(); // load all the users in the system
            let newUsers = snapshot.docs
                                .filter(doc => doc.data().name) // filter who set their name
                                .filter(doc => doc.data().token)
                                .map(doc => {
                                    return ({
                                        ...doc.data(), 
                                        id: doc.id,
                                    })
                                }).sort(() => 0.5 - Math.random());

            
            const w_snapshot = await firestore.collection('responses').doc(uid).get();
            const userResponse = w_snapshot.data();

            // TODO get from profile or userResponse
            const currentUser = newUsers.filter(doc => doc.id == uid)[0] || userResponse;

            setUser( currentUser );

            newUsers = newUsers.filter(doc => doc.id != uid);

            already_answered = userResponse ? Object.keys(userResponse.data || {}) : [];

            // also exclude collaborators
            let collaborators =  Array.from( new Set(Object.values(currentUser.prev_papers || {}).filter(p => p["authors"].length < 9).map(p => p["authors"]).map(author => author.map(a => a["authorId"])).flat()) );
            if(Object.values(currentUser.advisor_papers || {}).length) {
                collaborators = [...collaborators, ...Object.values(currentUser.advisor_papers || {}).map(p => p["author_mag_id"])];
                collaborators = Array.from( new Set(collaborators) );
            }
                

            // already_answered = [...already_answered, ...newUsers.filter(u => u.ssUrl  && collaborators.indexOf(Array.isArray(u.ssUrl) ? u.ssUrl[0]:u.ssUrl) != -1).map(u => u.id)];
            // console.log(collaborators);
            // console.log(newUsers)
            // console.log(newUsers.filter(u => !u.ssUrl  || collaborators.indexOf(Array.isArray(u.ssUrl) ? u.ssUrl[0]:u.ssUrl) == -1))
            // take out collaborators from user selection
            setUsers( newUsers.filter(u => !u.ssUrl  || collaborators.indexOf(Array.isArray(u.ssUrl) ? u.ssUrl[0]:u.ssUrl) == -1) );

            // load liked data
            // for(const u of [...newUsers, newUsers.filter(doc => doc.id == uid)[0]]) {
            //     if(u.liked && u.liked.length) continue;

            //     console.log(u.name)
            //     const soya_token = u['token'];
            //     const my_liked = await fetchLikedContent(soya_token);
                
            //     console.log(my_liked);
            //     let my_liked_ids = [];
            //     if (my_liked['myLists'].length) {
            //       my_liked_ids = my_liked['myLists'][0]['myListItems'].filter(p => p.conferenceId === conf_ID).map(p => p.contentId);
            //       console.log(my_liked_ids);
              
            //     }
              
            //     my_liked_ids = my_liked_ids.concat( my_liked['myScheduleSessions'].filter(p => p.conferenceId === conf_ID).map(p => p['myScheduleContents']).flat().map(p => p['contentId']) );
            //     console.log(my_liked_ids)

            //     const pub_content =  await getConferenceContent();
            //     console.log("pub_content", pub_content);
            
            //     const my_liked_contents = pub_content.filter(p => my_liked_ids.includes(p.id)).filter(p => p['abstract']);
            //     console.log("my_liked_contents", my_liked_contents);
                
            //     const liked = my_liked_contents.map(p => {
            //         return {"abstract": p["abstract"], "title": p["title"]}
            //     })
            //     console.log(liked);
            //     // setMy_liked_contents(my_liked_contents);
            
            //     // const liked_content = my_liked_contents.filter(p => p['abstract']);

            //     const ref = firestore.collection("profiles").doc(u.id);
                
            //     ref.set({"liked": liked}, {merge: true}); 

            // }

            
          
          
            

            // already_answered =

            // let s = [];
            // newUsers.forEach(function(r, i) {
            //     s.push(`#${i+1}. ${r.name}: ` + Object.values(r.prev_papers || {}).filter((a) => a.year > 2016).map(p => p.abstract));
                
            // }, this);

            
            // console.log(s.join("\n"));



    

            // console.log(newUsers);

            // const p = await firestore.collection('profiles').get(); // load all the users in the system

            // const p_ids = p.docs.map(d => d.id);
                      
            // console.log( newUsers.filter(n => !p_ids.includes(n.id)) );
            // newUsers.filter(n => !p_ids.includes(n.id)).forEach(function(element) {

            //     firestore.collection('profiles').doc(element.id).set(element, {merge:true});
                
            // }, this);
            

            // firestore.collection('profiles').doc(user.id).set(user, {merge:true});

            // newUsers.filter(n => ["JKGlNllrkVXvBxdfXk3GGbALhvb2", "XGiQT9qLJPXU3ZeObQlP4922FOx2", "noEHwSUbYVeIRsN3Uf04RPy9zLb2"].includes( n['id'] )).forEach(function(user) {
            //     console.log(user.name)
            //     let s = "";
            //     s = user['ssUrl'][0]

            //     debugger;
            //    downloadPaper(user, s)
                                    
            // }, this);       
            
        }
        

        fetchSettings();

        


    }, [])

    const drawNextResearcher = () => {
        // wait until users are loaded 
        if(!users.length) return;

        const a = users.filter(doc => !already_answered.includes(doc.id));
        
        if(!a.length) { 
            alert("You completed the survey! Thanks for participation.");
            //put dummy so the progress becomes 100%
            already_answered = users;
        }
        else setResearcher(a[0]);

        // console.log(a[0])
    }

    const getUrlParameter = (sParam) => {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    const saveSuccess = () => {
        // messageApi.open({
        //   type: 'success',
        //   content: 'Your response is autosaved',
        // });
      };

    const onFinish = (values: any) => {
        console.log("Success:", values);
        const uid = getUrlParameter("id");
        const ref = firestore.collection("responses").doc(uid);
        
        let v = {};
        for (const [key, value] of Object.entries(values)) {
            console.log(`${key}: ${value}`);
            if(key == "want-to-meet") v[key] = value || 2;
            else v[key] = value || 4;
          }
        // save with researcher ID in DB 
        ref.set({"data": {[researcher.id]: {...v, updatedAt: Date.now()}}}, {merge: true}); 

        // Show pop up that it is saved
        message.success('Your response is autosaved');

        form.resetFields();
        setTopicEnabled(true);

        already_answered.push(researcher.id);

        drawNextResearcher();
        pageChange(1);

        window.scrollTo(0, 0);
    };


    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

  const downloadPaper = (user, ssUrl) => {
    let query_url= `https://api.semanticscholar.org/graph/v1/author/${ssUrl}?fields=name,papers.authors,papers.title,papers.url,papers.year,papers.journal,papers.fieldsOfStudy,papers.abstract,affiliations,paperCount`;
    fetch(query_url, {
        headers: {
            // 'Ocp-Apim-Subscription-Key': process.env.REACT_APP_MAG_SUB_KEY,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'x-api-key': 'DIjEjQlI8x2zjnYM6Ehgw9jIsGnYl0ql86pat70w',
        }
    })
    .then(res => res.json())
    .then(paper_list => {
        // process the recent papers
        let papers = {};
        const non_arxivs = paper_list["papers"] // .filter(p =>  !("VFN" in p && p["VFN"].includes("arXiv")));
        if(true) {
            const d = new Date();
            
            non_arxivs.sort((a,b) => b.year - a.year);
            non_arxivs
                .map(p => {
                papers[p["paperId"]]= {
                    "author_mag_id": ssUrl, 
                    "title": p["title"],
                    "authors": p["authors"],
                    "year": p["year"],
                    "conference": p["journal"]? (p["journal"]["name"] || "") : "",
                    "abstract": p["abstract"]
                }
                return null;
            })

            
        }

        user["prev_papers"] = papers;
        firestore.collection('profiles').doc(user.id).set(user, {merge:true});
    })
  }

  const onChange = (key) => {
    console.log(key);
  };

  const infoForm = () => {
    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      };

    return (
        <Form name="basic" form={form} {...formItemLayout} onFinish={onFinish} onFinishFailed={onFinishFailed} initialValues={{
          }} onFieldsChange={(changedFields, allFields) => {
              if(changedFields.filter(f => f.name.includes("want-to-meet")).length ) {
                if(allFields.filter(f => f['name'].includes('want-to-meet'))[0].value > 1) setTopicEnabled(true);
                else setTopicEnabled(false);
              }
                
              if(changedFields.filter(f => f.name.includes("reasonText")).length)
                form.setFieldsValue({ reason: "other" });
              if(changedFields.filter(f => f.name.includes("topicText")).length)
                form.setFieldsValue({ topic: Array.from( new Set([...allFields.filter(f => f['name'].includes('topic'))[0].value || [], "other"]) ) });
          }}>

        {/* <Form.Item>
            This person is my colleague. 
            <Button type="primary" htmlType="submit">
            Next (Skip)
            </Button>
        </Form.Item> */}
        <br/><br/>

        {/* <b>With additional information about the researcher revealed above, please adjust your response. </b>
        <br/> */}

        <br/>
        <span>In a coffee break, <b>researchers like you</b> should talk to this person</span>
        <Form.Item name="want-to-meet" label="">
            <Slider min={1} max={3} defaultValue={2}
                marks={{
                1: "Not really",
                2: "Yes, if time is left after meeting people who they really should meet.",
                3: "Definitely yes",
                }}
            />
        </Form.Item>
        <br/>

        <span>If you meet this person, what would you talk about?</span>
        {/* <span>This researcher and I are complementary in terms of professional roles, skills, knowledge, and social (academic) network</span> */}
        <Form.Item name="topic" label="" style={{marginBottom: 0}}>
            <Checkbox.Group disabled={!topicEnabled}>
                <Checkbox value="ask-advice" >
                    Ask for advice
                </Checkbox>
                <Checkbox value="give-advice" >
                    Give advice
                </Checkbox>
                <Checkbox value="share-ideas" >
                    Share research ideas
                </Checkbox>
                <Checkbox value="explore-topics" >
                    Explore joint research topics
                </Checkbox>
                <Checkbox value="spend-time" >
                    Hang out
                </Checkbox>
                <Checkbox value="organize-visit" >
                    Organize a research visit
                </Checkbox>
                <Checkbox value="other" >
                    Other: 
                </Checkbox>
            </Checkbox.Group>
        </Form.Item>
        <Form.Item
            label=""
            name="topicText"
            >
            <Input disabled={!topicEnabled}/>
        </Form.Item>
        <br/>

        <span>What information about this researcher influences your answers the most?</span> 
        <Form.Item name="reason" label="" rules={[{ required: true, message: 'Please answer!' }]} style={{marginBottom: 0}}>        
            <Radio.Group>
                <Radio value="stage"><span>{stage_dict[researcher.stage]} ({Object.keys(researcher.prev_papers || {}).length} publication(s))</span></Radio>
                <Radio value="advisor" disabled={!researcher.advisor_name}>Advisor: {researcher.advisor_name || "Unknown"}</Radio>
                <Radio value="collaborator">Their collaborators</Radio>
                <Radio value="pub">Some of their publications</Radio>
                <Radio value="other" style={{display: "block"}}>Other: 
                </Radio>
            </Radio.Group>
        </Form.Item>
        <Form.Item
        label=""
        name="reasonText"
        
        >
            <Input />
        </Form.Item>
        <br/>

        <span>This researcher has similar research interests as me</span>
        <Form.Item name="similiar" label="">
            <Slider min={1} max={7} defaultValue={4}
                marks={{
                1: 'Strongly disagree',
                2: " ",
                3: " ",
                4: " ",
                5: " ",
                6: " ",
                7: 'Strongly agree',
                }}
            />
        </Form.Item>
        <br/>

        <span>This researcher works in an area I want to learn</span>
        <Form.Item name="complementary" label="">
            <Slider min={1} max={7} defaultValue={4}
                marks={{
                1: 'Strongly disagree',
                2: " ",
                3: " ",
                4: " ",
                5: " ",
                6: " ",
                7: 'Strongly agree',
                }}
            />
        </Form.Item>
        <br/>
        
        <span>I'd like to collaborate with this researcher</span>
        <Form.Item name="collaboration" label="">
            <Slider min={1} max={7} defaultValue={4}
                marks={{
                1: 'Strongly disagree',
                2: " ",
                3: " ",
                4: " ",
                5: " ",
                6: " ",
                7: 'Strongly agree',
                }}
            />
        </Form.Item>
        <br/>

        <span>This researcher and I have overlapping academic networks</span>
        {/* <span>This researcher and I are complementary in terms of professional roles, skills, knowledge, and social (academic) network</span> */}
        <Form.Item name="socialnetwork" label="">
            <Slider min={1} max={7} defaultValue={4}
                marks={{
                1: <span>Strongly disagree <br/>(I know of none of <br/>this researcher's collaborators)</span>,
                2: " ",
                3: " ",
                4: " ",
                5: " ",
                6: " ",
                7: 'Strongly agree',
                }}
            />
        </Form.Item>
        <br/><br/>

        <Divider/>
        <span>I know this researcher</span>
        {/* <span>This researcher and I are complementary in terms of professional roles, skills, knowledge, and social (academic) network</span> */}
        <Form.Item name="prior" label="">
            <Slider min={1} max={3} defaultValue={2}
                marks={{
                1: <span>No. I'm not sure <br/>who this researcher is<br/>or I don't know them</span>,
                2: <span>Kinda. I know <b>of</b> them</span>,
                3: <span>Yes. We have met</span>,
                }}
            />
        </Form.Item>
        <br/>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
            Next
            </Button>
        </Form.Item>
        </Form>
    );
    };

    const pageChange = (page) => {
        setCurrentPage(page);
        setMinIndex((page - 1) * 5);
        setMaxIndex(page * 5);
      };

  return (
      <>
      {getUrlParameter("id") ? 
        <>
            <PageHeader
            className="site-page-header"
            title="Coffee break"
            subTitle="Who would like to meet in a coffee break and why?"
            extra={[user.name]}
            />
            {displayQFlag ? 
                <div>
                    <div style={{marginLeft: "100px", marginRight: "100px"}}>
                        <Progress percent={Object.keys(already_answered).length < mandatory_threshold ? Math.ceil( Object.keys(already_answered).length/mandatory_threshold*100 ): Math.ceil( Object.keys(already_answered).length/users.length*100 )} status="active" strokeColor={{ from: '#108ee9', to: '#87d068' }} />
                        <br/><br/>
                        {Object.keys(already_answered).length >= mandatory_threshold && <p style={{ width: 900 }}>You have responded more than a minumum amount we need for analysis. We would greatly appreciate if you continue the survey, however, feel free to stop at any point.</p>}
                        <p style={{ width: 900 }}>This is a profile of one of researchers attending the social hour. <b>Considering only information given below</b>, please answer the following question -- you might recognize this person by looking at the profile, but still answer wihtout your prior knowledge or interaction with this person. </p>
                        {
                            true ? 
                            <Card title={<span>{stage_dict[researcher.stage]} ({Object.keys(researcher.prev_papers || {}).length} publication(s))</span>} extra={researcher.advisor_name ? <span>Advisor: {researcher.advisor_name}</span>:""} style={{ width: 900 }}>
                            {Object.keys(researcher.prev_papers || {}).length ?
                            <>
                                <p>{Object.values(researcher.prev_papers || {})
                                    .sort((a, b) => b.year - a.year)
                                    .filter(v => Array.isArray(v["authors"]) && v["authors"].length > 1) //.slice(0, 3)
                                        .map((v, index) => 
                                        index >= minIndex &&
                                        index < maxIndex &&
                                        (<p key={index}>
                                            <b>{v["title"]} </b> 
                                            {/* {v["conference"].replace(/\d/g, "*")} */}
                                            {v["conference"]} {v["year"]} {v["abstract"] && <Popover content={<div style={{maxWidth: "600px"}}>{v["abstract"]}</div>}>
                                                <Text mark>abstract</Text>
                                            </Popover>}<br/>
                                            <small>{Array.isArray(v["authors"]) ? v["authors"] //.filter(a => v["author_mag_id"] != a["authorId"])
                                                .map(a => v["author_mag_id"] === a["authorId"] ? <span><i>This researcher</i>, </span>: a['name'] + ", ") : v["authors"]}</small>    
                                        </p>)
                                    )}</p>
                                    <Pagination
                                        pageSize={5}
                                        current={currentPage}
                                        total={Object.keys(researcher.prev_papers || {}).length}
                                        onChange={pageChange}
                                        style={{ bottom: "0px" }}
                                    />
                                </>
                                :
                                <>
                                    <p>This researcher has no publication but interested in research like following:</p>
                                    {researcher.liked.slice(0, 3).map(v =>
                                        <p>
                                            <b>{v["title"]}</b>
                                            <small>{v["abstract"]}</small>
                                        </p>
                                    )}
                                    
                                </>
                            }
                            </Card>
                            :
                            <Card title={<span>{researcher.name}, {stage_dict[researcher.stage]} ({Object.keys(researcher.prev_papers || {}).length} publication(s))</span>} extra={researcher.advisor_name ? <span>Advisor: {researcher.advisor_name}</span>:""} style={{ width: 900 }}>
                            {Object.keys(researcher.prev_papers || {}).length ?
                            <>
                                <p>{Object.values(researcher.prev_papers || {}).sort((a, b) => b.year - a.year)
                                        .map((v, index) => 
                                        index >= minIndex &&
                                        index < maxIndex &&
                                        (<p key={index}>
                                            <b>{v["title"]}</b> {v["conference"]} {v["year"]} {v["abstract"] && <Popover content={<div style={{maxWidth: "600px"}}>{v["abstract"]}</div>}>
                                                <Text mark>abstract</Text>
                                            </Popover>}<br/>
                                            <small>{Array.isArray(v["authors"]) ? v["authors"].map(a => a['name']).join(", ") : v["authors"]}</small>    
                                        </p>)
                                    )}</p>
                                    <Pagination
                                        pageSize={5}
                                        current={currentPage}
                                        total={Object.keys(researcher.prev_papers || {}).length}
                                        onChange={pageChange}
                                        style={{ bottom: "0px" }}
                                    />
                                </>
                                :
                                <>
                                    <p>Papers that they are interested in</p>
                                </>
                            }
                            </Card>
                        }
                        
                        {infoForm()}
                        
                    </div>
                </div>
                :
                <div style={{marginLeft: "100px"}}>
                    <span>Imagine you are attending a coffee break. There is limited time, so you can not meet everyone. Here’s the list of attendees. Skim through their profile and start answering to question once you are ready. </span>
                    <Affix offsetTop={10} style={{float: "right", margin: "100px", marginTop: "0px"}}>
                        <Button type="primary" size="large" onClick={() => {setUsers([...users.sort(() => 0.5 - Math.random())]);drawNextResearcher();setDisplayQFlag(true)}}>
                        Start survey
                        </Button>
                    </Affix>
                    <Collapse defaultActiveKey={[0]} onChange={onChange} style={{marginTop: "100px"}}>
                        {users.map((u,i) => <Panel header={`${u.name}, ${stage_dict[u.stage]}`} key={i}>
                            <h3>Recent papers</h3>
                            <p>{Object.values(u.prev_papers || {}).sort((a, b) => b.year - a.year).slice(0, 10) //.filter(a => a.year > 2018)
                                        .map((v, index) => 
                                        <p key={index}>
                                            <b>{v["title"]}</b> {v["conference"]} {v["year"]}<br/>
                                            <small>{Array.isArray(v["authors"]) ? v["authors"].map(a => a['name']).join(", ") : v["authors"]}</small>    
                                        </p>
                                        // .filter((v, index) => (user.prev_papers[v]["conference"] != "Proceedings of the ACM on Human-Computer Interaction") && (user.prev_papers[v]["year"] == 2021))
                                        
                                    )}</p>
                        </Panel>)}
                    </Collapse>
                </div>
                }</>
        :
        <span>Invalid link! Please use the custom link. If you can't find it, please email me at soya@mit.edu</span>
    }
    </>
  );
};
export default LabelResearchers;